/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState } from "react";
import Documents from "./Documents";
import SupplierDocuments from "./SupplierDocuments";

function IndexDocument() {
    const[isCompany, setIsCompany] = useState(false);
  var data = JSON.parse(localStorage.getItem("authority"));
  useEffect(() => {
    if (data.roles.includes("SUBSCRIBER_ADMIN")) {
        setIsCompany(true);
    } else if (data.roles.includes("SUPPLIER_ADMIN")) {
        setIsCompany(false);
    }
  }, [data.roles]);
  return (
    <>
        {isCompany ? <Documents /> : <SupplierDocuments />}
    </>
  );
}

export default IndexDocument;
